import Web3 from 'web3'
import { provider } from 'web3-core'

export const NETWORK = process.env.REACT_APP_ETH_NETWORK || ''

type ConnectWalletResponse = {
  web3: any
  networkError: boolean
}

type ConnectWalletOptions = {
  provider: provider
}

export const connectWalletWithProvider = async (options: ConnectWalletOptions): Promise<ConnectWalletResponse> => {
  try {
    const provider = options.provider
    const _web3: any = new Web3(provider)

    const _network = await _web3.eth.net.getNetworkType()
    return {
      web3: _web3,
      networkError: _network && NETWORK.toLowerCase().indexOf(_network.toLowerCase()) === -1,
    }
  } catch (e) {
    console.log(e)
    return {
      web3: null,
      networkError: true,
    }
  }
}

export const shortAddress = (address: string) => `${address.slice(0, 6)}...${address.slice(-4)}`
